import styled from 'styled-components';

export const TableBody = styled.tbody`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
